"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagLabel = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var MAX_CHARS = 30;
var TRUNCATED_ENDING = '...';
var truncateLabel = function (label) {
    return label.length <= MAX_CHARS
        ? label
        : label.substring(0, MAX_CHARS) + TRUNCATED_ENDING;
};
exports.TagLabel = function (_a) {
    var label = _a.label, _b = _a.truncate, truncate = _b === void 0 ? false : _b;
    return label !== undefined ? (react_1.default.createElement(LabelSpan, null, truncate ? truncateLabel(label) : label)) : null;
};
var LabelSpan = styled_components_1.default.span(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  white-space: normal;\n"], ["\n  white-space: normal;\n"])));
var templateObject_1;
